// T506: first, so the request counter wraps fetch before the Supabase client captures it.
import "./lib/pageActivity";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/alps-intensity.css";
import "./styles/dealflow-card-state.css";
import { captureAttributionFromUrl, captureArtifactAttributionFromUrl } from "./lib/viralAttribution";
import { initClarity } from "./lib/clarityOptout";
import { routeOAuthReturnError } from "./lib/oauth-return-error";
import { initReportReferral } from "./lib/reportReferral";
import { toast as sonnerToast } from "sonner";
import { installPlainToastGuard } from "./lib/plainError";
import { supabase } from "./integrations/supabase/client";
import { scrubAuthTokensFromUrl } from "./lib/authUrlScrub";

// T395: every sonner toast string passes through plainUserText, so no snake_case code or
// raw provider/database error reaches a user. Originals are logged to the console.
installPlainToastGuard(sonnerToast);

// Microsoft Clarity — whole-funnel session analytics (project y9rayhq162). Injected
// at runtime from the SPA entry so it fires on every dashboard page (Vite strips
// inline <head> tags from index.html, so the static snippet alone is unreliable).
// Not initialised in a browser that opted out with ?clarity_optout=1.
initClarity();

// T883: once supabase-js has read a sign-in return (/auth#access_token=...), no token stays in
// the address bar: replaceState drops every token key and the bare "#" supabase-js leaves.
void supabase.auth.initialize().then(scrubAuthTokensFromUrl, scrubAuthTokensFromUrl);

// Capture ?via=foxXXX&from=launch_pack on first paint so signups get
// attributed back to the Launch Pack referrer.
captureAttributionFromUrl();
// Capture ?mf_a=<artifact_id> so a signup gets attributed back to the artifact
// whose link the visitor followed (first-touch wins).
captureArtifactAttributionFromUrl();
// T355: a buyer's invite link (?rr=) is kept and, once signed in, linked to the account.
initReportReferral();

// A failed LinkedIn/Google sign-in comes back with ?error=... (on the site root when the
// auth server lost track of the destination). It goes to /auth with a plain message and
// next= kept (cc_tasks row 297, T332). When it navigates away there is nothing to render.
if (!routeOAuthReturnError()) {
  createRoot(document.getElementById("root")!).render(<App />);
}
